export const PLACES = {
  ADS_LIST: 'adsList',
  PROFESSIONAL_STOCK: 'professionalStock',
  PROFESSIONAL_STOCK_RENTING: 'professionalStockRenting',
  SUBSCRIPTION_ADS_LIST: 'subscriptionAdsList'
}

export const SEARCH_USE_CASE_BY_PLACE = {
  [PLACES.ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK]: 'get_stock_url_params_search_use_case',
  [PLACES.PROFESSIONAL_STOCK_RENTING]: 'get_stock_url_params_search_use_case',
  [PLACES.SUBSCRIPTION_ADS_LIST]: 'get_url_params_search_use_case',
  [PLACES.TECHNICAL_DETAILS]: 'get_search_url_vehicles_use_case'
}
